<template>
  <div>
    <Row>
      <Col class="label" span="4">用户类型：</Col>
      <Col span="20">{{ info.templateType == 0 ? "个人" : "企业" }}</Col>
    </Row>
    <template v-if="info.templateType !== 0">
      <Row>
        <Col class="label" span="4">企业名称(中文)：</Col>
        <Col span="20">{{ info.chineseBusinessName }}</Col>
      </Row>
      <Row>
        <Col class="label" span="4">企业名称(英文文)：</Col>
        <Col span="20">{{ info.englishBusinessName }}</Col>
      </Row>
    </template>
    <!-- <Row>
      <Col class="label" span="4">域名所有者(中文)：</Col>
      <Col span="20">{{ info.chineseName }}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">域名所有者(英文)：</Col>
      <Col span="20">{{ info.chineseName }}</Col>
    </Row> -->
    <Row>
      <Col class="label" span="4">联系人(中文)：</Col>
      <Col span="20">{{ info.englishName }}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">联系人(英文)：</Col>
      <Col span="20">{{ info.englishName }}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">电子邮箱：</Col>
      <Col span="20">{{ info.email }}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">地区：</Col>
      <Col span="20">{{ info.country || "" + info.province|| "" + info.city || "" + info.street || ""}}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">通信地址(中文)：</Col>
      <Col span="20">{{ info.street2 }}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">邮编：</Col>
      <Col span="20">{{ info.postcode }}</Col>
    </Row>
    <Row>
      <Col class="label" span="4">电话：</Col>
      <Col span="20">{{ info.phone }}</Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "smTableExpand",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
